
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dev-to-dev",
      function () {
        return require("private-next-pages/dev-to-dev/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dev-to-dev"])
      });
    }
  